import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useCounts } from '../../contexts/counts-context';
import { PanelIcon } from '../../pages/user-panel/user-panel';
import './mobile-tab-bar.css';

// the post button sits between the two pairs; `count` names the counter that lights the dot
const LEFT_TABS = [
    { title: 'tab_home', path: '/', icon: 'home' },
    { title: 'tab_messages', path: '/korisnik/poruke', icon: 'msg', count: 'messages' },
];
const RIGHT_TABS = [
    { title: 'tab_notifications', path: '/korisnik/obavestenja', icon: 'bell', count: 'notifications' },
    { title: 'tab_my_listings', path: '/korisnik/oglasi', icon: 'folder' },
];
const POST_PATH = '/postavi-oglas';

// the ad form has its own bar at the bottom
const HIDDEN_ON = [POST_PATH];

export const MobileTabBar = () => {
    const { t } = useTranslation(['navigation']);
    const location = useLocation();
    const counts = useCounts();

    if (HIDDEN_ON.some(path => location.pathname.startsWith(path))) return null;

    const tab = ({ title, path, icon, count }) => {
        const active = location.pathname === path;
        return (
            <Link key={path} to={path} className={`hs-tab ${active ? 'on' : ''}`} aria-current={active ? 'page' : undefined}>
                <span className='hs-tab-icon'>
                    <PanelIcon name={icon} size={22} />
                    {count && counts[count] > 0 && <span className='hs-tab-dot' aria-label={t('tab_new')}></span>}
                </span>
                <span className='hs-tab-label'>{t(title)}</span>
            </Link>
        );
    };

    return (
        <>
            {/* keeps the end of the page from hiding behind the bar */}
            <div className='hs-tabbar-space'></div>
            <nav className='hs hs-tabbar' aria-label={t('tab_menu')}>
                {LEFT_TABS.map(tab)}
                <Link to={POST_PATH} className='hs-tab hs-tab-post' onClick={() => sessionStorage.removeItem('currentPage')}>
                    <span className='hs-tab-post-btn'>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round"><path d="M12 5v14M5 12h14" /></svg>
                    </span>
                    <span className='hs-tab-label'>{t('tab_post')}</span>
                </Link>
                {RIGHT_TABS.map(tab)}
            </nav>
        </>
    );
};
